export const WithPublic = <P extends object>(Component: React.ComponentType<P>) => (props: P) => <Component {...props} isPublic />;